// Título de bloco dentro da aba, com ação à direita (WEB-121, canvas `SectionHead`).

import type { ReactNode } from 'react';

export function SectionHead({
  title,
  hint,
  action,
}: {
  title: string;
  hint?: string;
  action?: ReactNode;
}) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'space-between',
        gap: 12,
        flexWrap: 'wrap',
      }}
    >
      <div style={{ minWidth: 0 }}>
        <h2
          style={{
            margin: 0,
            fontSize: 18,
            fontWeight: 800,
            letterSpacing: '-.01em',
            color: 'var(--piao-ink)',
          }}
        >
          {title}
        </h2>
        {hint !== undefined && (
          <p style={{ margin: '4px 0 0', fontSize: 13, color: 'var(--piao-muted)' }}>{hint}</p>
        )}
      </div>
      {action}
    </div>
  );
}
